// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@media only screen and (min-width: 1024px) and (max-width: 1400px) {
.action-buttons {
    flex-direction: column-reverse;
    justify-content: center;
    align-items: flex-end;
}
}
@media only screen and (max-width: 1024px) {
.action-buttons {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 1.92rem;
}
}
.view-iybr-dropdown-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.8rem;
}
.view-iybr-dropdown-item h6 {
  margin: 0;
}
.view-iybr-dropdown-item--trigger {
  column-gap: 0.32rem;
  margin-right: 1.28rem;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
